import { API } from '../config/AppConfig';
import {
  GET_NOTIFICATIONS,
  CHANGE_NOTIFICATION_STATUS,
  MARK_ALL_READ_NOTIFICATIONS,
} from '../constants/Endpoints';

class NotificationRepository {
  async getNotifications(currentPage, readFilter) {
    const queryParams = { page: currentPage };
    if (readFilter !== undefined) queryParams.read = readFilter;
    const response = await API.get(GET_NOTIFICATIONS, { queryParams });
    return response;
  }

  async changeNotificationStatus(notificationId) {
    const response = await API.patch(CHANGE_NOTIFICATION_STATUS, {
      pathParams: { notificationId },
      body: { read: true },
    });
    return response;
  }

  async markUnread(notificationId) {
    const response = await API.patch(CHANGE_NOTIFICATION_STATUS, {
      pathParams: { notificationId },
      body: { read: false },
    });
    return response;
  }

  async markAllRead() {
    const response = await API.post(MARK_ALL_READ_NOTIFICATIONS, {});
    return response;
  }
}

const notificationRepository = new NotificationRepository();
export default notificationRepository;
